import Vue from 'vue';
import { formatDate, currency } from '../util/index.js'


Vue.filter('dateFilter', (val, fmt = 'yyyy-MM-dd') => {
    if (!val) return '-';
    let time = new Date(val);
    return formatDate(time, fmt)
});

Vue.filter('currency', (val, currencys, decimals) => {
    return currency(val, currencys, decimals);
});

Vue.filter('gender', (val) => {
    return {
        "UNKNOWN": "未知",
        "MALE": "先生",
        "FEMALE": "女士",
        "CONFIDENTIALITY": "保密"
    }[val]
});

Vue.prototype.$dateFilter = Vue.filter('dateFilter');
Vue.prototype.$currency = Vue.filter('currency');
Vue.prototype.$gender = Vue.filter('gender');



// WEBPACK FOOTER //
// ./src/filters/index.js